const GameSettingType = {
    Sets: "SETS",
    Points: "POINTS",
    LeadPoint: "LEAD_POINTS"
}

export default GameSettingType;